import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { Security, SecurityProps } from './securitiesTypes';

const syncSecuritiesPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<SecurityProps>>();
const securityPayloadCreator = getPayloadCreator<Security>();

export const getSecurities = createAction('GET_SECURITIES', getPayloadCreator());
export const getSecuritiesSuccess = createAction('GET_SECURITIES_SUCCESS', syncSecuritiesPayloadCreator);
export const getSecuritiesFailure = createAction('GET_SECURITIES_FAILURE', errorPayloadCreator);

export const createSecurity = createAction('CREATE_SECURITY', securityPayloadCreator);
export const createSecuritySuccess = createAction('CREATE_SECURITY_SUCCESS', securityPayloadCreator);
export const createSecurityFailure = createAction('CREATE_SECURITY_FAILURE', errorPayloadCreator);

export const updateSecurity = createAction('UPDATE_SECURITY', securityPayloadCreator);
export const updateSecuritySuccess = createAction('UPDATE_SECURITY_SUCCESS', securityPayloadCreator);
export const updateSecurityFailure = createAction('UPDATE_SECURITY_FAILURE', errorPayloadCreator);

export const deleteSecurity = createAction('DELETE_SECURITY', securityPayloadCreator);
export const deleteSecuritySuccess = createAction('DELETE_SECURITY_SUCCESS', securityPayloadCreator);
export const deleteSecurityFailure = createAction('DELETE_SECURITY_FAILURE', errorPayloadCreator);
